import { CascadiaMiniIcon } from "@certn/cascadia-tokens";
import { Button, ButtonProps } from "react-aria-components";

import { InputContainer } from "./InputContainer";

interface Props extends ButtonProps {
  leftIcon?: CascadiaMiniIcon;
  rightIcon?: CascadiaMiniIcon;
  compact?: boolean;
  onToggle?: () => void;
}

export function InputButton(props: Props) {
  const { leftIcon, rightIcon, compact, ...buttonProps } = props;

  return (
    <InputContainer
      leftIcon={leftIcon}
      rightIcon={rightIcon}
      compact={compact}
      onToggle={props.onToggle}
      isDisabled={props.isDisabled}
    >
      <Button {...buttonProps} />
    </InputContainer>
  );
}
